<template>
  <div class="video-page">
    <div class="player-card">
      <div class="player-header">
        <a-icon type="caret-right" class="player-icon" />
        <span class="player-title">{{ videoName }}</span>
      </div>
      <div class="player-body">
        <video-player
          v-if="videoSrc"
          :key="playerKey"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @error="onPlayerError"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'trainingVideo',
  data() {
    return {
      playerKey: 0,
      videoName: '培训视频',
      playerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        controls: true,
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true,
          playbackRateMenuButton: true,
        },
        sources: [],
        poster: '',
        fluid: true,
        notSupportedMessage: '您的浏览器不支持此视频格式，请更换浏览器重试',
        techOrder: ['html5', 'flash'],
      },
    }
  },
  computed: {
    videoSrc() {
      return this.playerOptions.sources.length > 0 ? this.playerOptions.sources[0].src : ''
    },
  },
  watch: {
    // 菜单切换时 query 参数变化，重新加载视频
    '$route.query.video': {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadVideo(val)
        }
      },
    },
  },
  methods: {
    loadVideo(fileName) {
      // 用 key 变化强制 Vue 销毁旧播放器组件再重建，避免手动 dispose 引发的空指针
      this.playerKey++

      this.videoName = fileName.replace(/\.[^.]+$/, '')

      let videoUrl = fileName
      if (!/^https?:\/\//.test(fileName)) {
        if (!fileName.startsWith('/')) {
          videoUrl = '/videos/' + fileName
        }
      }

      const ext = fileName.split('.').pop().toLowerCase()
      const mimeMap = { webm: 'video/webm', ogg: 'video/ogg', ogv: 'video/ogg', mov: 'video/quicktime', flv: 'video/x-flv', mkv: 'video/x-matroska' }
      const mimeType = mimeMap[ext] || 'video/mp4'

      this.playerOptions.sources = [{ src: videoUrl, type: mimeType }]
    },
    onPlayerError() {
      this.$message.error('视频加载失败，请检查视频文件是否存在')
    },
  },
}
</script>

<style lang="scss" scoped>
.video-page {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
}

.player-card {
  width: 100%;
  max-width: 1400px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  background: #1a1a2e;
}

.player-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(90deg, #16213e, #1a1a2e);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.player-icon {
  font-size: 18px;
  color: #e94560;
  margin-right: 10px;
}

.player-title {
  font-size: 15px;
  font-weight: 500;
  color: #eaeaea;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.player-body {
  background: #000;
  line-height: 0;
}

.video-player {
  width: 100%;
}

// ============ 移动端适配 ============
@media screen and (max-width: 768px) {
  .video-page {
    padding: 0;
    background: #000;
  }

  .player-card {
    max-width: none;
    border-radius: 0;
    box-shadow: none;
  }

  .player-header {
    background: linear-gradient(90deg, #16213e, #1a1a2e);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    padding: 10px 14px;
  }

  .player-title {
    color: #eaeaea;
    font-size: 13px;
  }

  .player-body {
    background: transparent;
  }
}
</style>
